import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./WhiteLabelFooter.css";

const WhiteLabelFooter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="custom-footer-white-label">
        <div className="footer-content-white-label">
            <div
            className="footer-branding-white-label"
            onClick={() => navigate("/")}
            >
            <span>{t("white_labelled_footer.scheduling_by")}</span>
            <img
                src="/images/logos/PlusLife-Logo-Primary-Filled.svg"
                alt="Clinic Logo"
                className="footer-logo-white-label"
            />
            </div>

            <span className="footer-separator">|</span>

            <span className="footer-link" onClick={() => navigate("/terms")}>
            {t("white_labelled_footer.terms_of_use")}
            </span>

            <span className="footer-separator">|</span>

            <a
            className="footer-link"
            href="https://plus-life.ca/"
            target="_blank"
            rel="noopener noreferrer"
            >
            {t("white_labelled_footer.practice_here")}
            </a>
        </div>
    </footer>
  )
};

export default WhiteLabelFooter;
